<div *ngIf="openWorkExperienceForm">
  <app-workexperience-modal [header]="'Current Organization Details'" (profileListener)="submitWorkExp($event)"
    [availableWorkExperience]="[]" (ModalEmitter)="submitWorkExp($event)" (closeEmitter)="closeModal($event)" [ButtonName]="'Submit'"
    [content]="'PROFILE'"></app-workexperience-modal>

</div> 


<!-- HTML with all Angular logic preserved -->
<div class="pricing-container">
  <div class="pricing-header">
    <h1 class="pricing-title">Supercharge your technology recruitment. Start free.</h1>
    <p class="pricing-subtitle">Lifetime access to Free plan. No credit card needed.</p>

    <div class="toggle-container">
      <button class="toggle-btn" style="min-width:250px;" [ngClass]="{'active': planType === 'EMPLOYER'}" (click)="handlePlanTypeChange('EMPLOYER')">
        For Employers
      </button>
      <button class="toggle-btn" style="min-width:250px;"  [ngClass]="{'active': planType === 'AGENCY'}" (click)="handlePlanTypeChange('AGENCY')">
        For Agencies
      </button>
    </div>

    <div class="billing-container">
      <span class="billing-label">Billed </span>
    </div>

    <div class="toggle-container">
      <button class="toggle-btn" [ngClass]="{'active': billingCycle === 'monthly'}"
        (click)="handleBillingCycleChange('monthly')">
        Monthly
      </button>
      <button class="toggle-btn" [ngClass]="{'active': billingCycle === 'annually'}"
        (click)="handleBillingCycleChange('annually')">
        Annually <span class="discount-label">(upto 20%)</span>
        <span class="popular-badge">
          Most Popular
        </span>
      </button>
    </div>
  </div>

  <!-- Pricing Plans -->
  <div class="plans-container">

    <div class="plans-grid">
      <div *ngFor="let plan of planRespones"
        class="plan-card" [ngClass]="{'popular': plan.popular}">

        <!-- Most Popular Tag -->
        <div *ngIf="plan.popular" class="popular-tag">
          <span class="popular-text">Most Popular</span>
        </div>

        <div class="plan-content">
          <!-- HEADER - Plan Name & Description -->
          <div class="plan-header">
            <h3 class="plan-title">{{ plan.subcriptionType }}</h3>
            <p class="plan-description" [attr.data-full-text]="plan.description">{{ plan.description }}</p>
          </div>

          <!-- PRICING SECTION -->
          <div [ngClass]="{ 'custom-height-annually': billingCycle === 'annually', 'custom-height-monthly': billingCycle === 'monthly' }">
            <!-- Free Plan -->
            <div *ngIf="plan.subcriptionType === 'Free'">
              <p class="price-large">
                $0 <span class="price-unit">USD/{{ billingCycle === 'monthly' ? 'month' : 'year' }}</span>
              </p>
              <p class="price-subtitle">Free forever</p>
            </div>
            
            <!-- ScaleX Plan -->
            <p class="custom-price" *ngIf="plan.subcriptionType === 'ScaleX'">
              Custom pricing
            </p>
            
            <!-- Other Plans (Starter, Growth) -->
            <ng-container *ngIf="plan.subcriptionType !== 'Free' && plan.subcriptionType !== 'ScaleX'">
              <!-- Monthly Billing -->
              <div *ngIf="billingCycle === 'monthly'">
                <p class="price-large">
                  ${{ plan.monthlySubscriptionAmount }} <span class="price-unit">USD/month</span>
                </p>
              </div>
              
              <!-- Annual Billing -->
              <div *ngIf="billingCycle === 'annually'">
                <p class="price-large">
                  ${{ plan.monthlysubscriptionForAnnual || (plan.annualSubscriptionAmount / 12).toFixed(0) }} 
                  <span class="price-unit">USD/month</span>
                </p>
                <p class="annual-price">
                  ${{ plan.annualSubscriptionAmount }} USD/year
                </p>
                
                <!-- Discount information -->
                <p class="save-text">
                  Save <span class="modifiedcss">${{ (plan.monthlySubscriptionAmount * 12 - plan.annualSubscriptionAmount).toFixed(0) }}</span>/year
                </p>
                <p class="discount-text">
                  Bundle Discount: <span class="modifiedcss">{{ plan.annualDiscountRate }}%</span>
                </p>
              </div>
            </ng-container>
          </div>

          <!-- BUTTON SECTION -->
          <div class="button-container">
            <!-- Free Plan -->
            <button *ngIf="plan.subcriptionType === 'Free' && MemberShipType !== 'Free'" class="plan-button"
            [disabled]="MemberShipType !== 'Free'">
              Free Plan
            </button>
          
            <!-- Current Plan -->
            <button *ngIf="plan.subcriptionType === MemberShipType" class="plan-button current-plan">
              Current Plan
            </button>
          
            <!-- Contact Sales -->
            <button *ngIf="plan.subcriptionType === 'ScaleX' && MemberShipType !== 'ScaleX'" 
                    class="plan-button" (click)="openModel(template)">
              Contact Sale
            </button>
          
            <!-- Get Started - Upgrade Plan -->
            <button *ngIf="plan.subcriptionType !== 'ScaleX' && plan.subcriptionType !== 'Free' && plan.subcriptionType !== MemberShipType" 
                    class="plan-button" (click)="upgradePlan(plan)" [disabled]="MemberShipType === 'ScaleX' || planWiseOrder[plan.subcriptionType] < planWiseOrder[MemberShipType]">
              Get Started
            </button>
          </div>

          <!-- FEATURES SECTION -->
          <div class="features-container">
            <ul class="features-list">
              <li *ngFor="let feature of plan?.specifications" class="feature-item">
                <span class="feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd" />
                  </svg>
                </span>
                <span class="feature-text">
                  {{ feature.featureName }}
                </span>
              </li>
            </ul>
            
            <!-- CORE FEATURES SECTION -->
            <div class="core-features">
              <h4 class="core-features-title">CORE FEATURES</h4>
              <ul class="features-list">
                <li *ngFor="let feature of plan?.coreFeatures" class="feature-item">
                  <span class="feature-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd" />
                    </svg>
                  </span>
                  <span class="feature-text">
                    {{ feature.featureName }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngFor="let item of 1 | times; let i = index">
      <app-common-skeleton *ngIf="planRespones.length == 0" [NameOftheScreen]="'pricing'"></app-common-skeleton>
    </ng-container>

    <div class="features-container899" *ngIf="planRespones.length > 0">
      <!-- Feature list toggle button -->
      <div class="toggle-container899">
        <button (click)="toggleFeatureTable()" class="toggle-button899">
          <span>{{ showFeatureTable ? 'Hide Features List' : 'Complete Features List' }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="toggle-icon899" viewBox="0 0 20 20" fill="currentColor"
               [ngClass]="{'rotate899': showFeatureTable}">
            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </button>
      </div>
    
      <!-- Features table (conditionally shown) -->
      <div *ngIf="showFeatureTable" class="features-table899">
        <!-- Table header -->
        <div class="table-header899">
          <div class="grid-container899">
            <div class="header-cell899 feature-column899">Feature Groups</div>
            <div class="header-cell899 plan-column899">Free</div>
            <div class="header-cell899 plan-column899">Starter</div>
            <div class="header-cell899 plan-column899">Growth</div>
            <div class="header-cell899 plan-column899">ScaleX</div>
          </div>
        </div>
    
        <!-- Table content (scrollable) -->
        <div class="table-content899">
          <!-- Loop through categories -->
          <ng-container *ngFor="let category of featureGroupList">
            <!-- Category header -->
            <div class="category-row899">
              <div class="grid-container899">
                <div class="category-cell899">{{ category.groupName }}</div>
                <div class="category-spacer899"></div>
                <div class="category-spacer899"></div>
                <div class="category-spacer899"></div>
                <div class="category-spacer899"></div>
              </div>
            </div>
    
            <!-- Features in this category -->
            <ng-container *ngFor="let feature of getFeaturesByGroupId(category.groupId)">
              <div class="feature-row899">
                <div class="grid-container899">
                  <div class="feature-name-cell899"  >{{ feature.featureName }}</div>
                  
                  <!-- Free plan -->
                  <div class="feature-availability-cell899">
                    <svg *ngIf="feature.availability.Free" class="checkmark-icon899" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                    <span *ngIf="!feature.availability.Free" class="dash-icon899">-</span>
                  </div>
                  
                  <!-- Starter plan -->
                  <div class="feature-availability-cell899">
                    <svg *ngIf="feature.availability.Starter" class="checkmark-icon899" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                    <span *ngIf="!feature.availability.Starter" class="dash-icon899">-</span>
                  </div>
                  
                  <!-- Growth plan -->
                  <div class="feature-availability-cell899">
                    <svg *ngIf="feature.availability.Growth" class="checkmark-icon899" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                    <span *ngIf="!feature.availability.Growth" class="dash-icon899">-</span>
                  </div>
                  
                  <!-- ScaleX plan -->
                  <div class="feature-availability-cell899">
                    <svg *ngIf="feature.availability.ScaleX" class="checkmark-icon899" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                    <span *ngIf="!feature.availability.ScaleX" class="dash-icon899">-</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>


  </div>
</div>


<ng-template #template>
  <div class="common-header-flex">
    <div>Contact us</div>
    <button>
      <span (click)="closeModel()" class="common-close">&times;</span>
    </button>
  </div>
  <div>
    <form [formGroup]="contactUs">
      <div class="hpanel gs-card">
        <div class="panel-body gs-card-bodygs-card-body">
          <div class="app-form">
            <div class="form-group">
              <div class="row">
                <label for="firstName" class="control-label required-field col-sm-4 text-right">First Name</label>
                <div class="col-sm-8">
                  <input maxlength="21" type="text" id="firstName" formControlName="firstName" placeholder="First Name"
                    class="form-control input-sm" required>
                  <div *ngIf="f.firstName.invalid && ( isSubmitted || f.firstName.dirty || f.firstName.touched )"
                    class="error-msg">
                    <div *ngIf="f.firstName.hasError('required') && f.firstName.touched">First name is required.</div>
 
                    <div class="error-msg w-wrap " *ngIf="f.firstName.hasError('maxword')">
                      {{FORMERROR.FIRSTNAME_MAX}}
                    </div>
                    <div *ngIf="f.firstName.hasError('pattern')&& !f.firstName.hasError('maxword')"
                      class="error-msg w-wrap ">
                      Enter valid first Name
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <label for="lastName" class="control-label required-field col-sm-4 text-right">Last Name</label>
                <div class="col-sm-8">
                  <input maxlength="41" type="text" id="lastName" formControlName="lastName" placeholder="Last Name"
                    class="form-control input-sm" required>
                  <div *ngIf="contactUs.get('lastName').hasError('required') && contactUs.get('lastName').touched"
                    class="error-msg">
                    Last name is required.
                  </div>
               
                  <div class="error-msg w-wrap " *ngIf="f.lastName.hasError('maxword')">
                    {{FORMERROR.LASTNAME_MAX}}
                  </div>
                  <div *ngIf="f.lastName.hasError('pattern') && !f.lastName.hasError('maxword')"
                    class="error-msg w-wrap ">
                    {{FORMERROR.FIRSTNAME_VALID}}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <label for="workEmail" class="control-label required-field col-sm-4 text-right">Work Mail</label>
                <div class="col-sm-8">
                  <input maxlength="51" type="email" id="workEmail" formControlName="workEmail" placeholder="Work Email"
                    class="form-control input-sm" required>
                  <div *ngIf="contactUs.get('workEmail').hasError('required') && contactUs.get('workEmail').touched"
                    class="error-msg">
                    Work mail is required.
                  </div>
                   
                  <div class="error-msg"
                    *ngIf=" contactUs.get('workEmail').hasError('pattern') && !contactUs.get('workEmail').hasError('maxword')">
                    {{FORMERROR.EMAIL_VALID}}
                  </div>
                  <div class="error-msg" *ngIf="contactUs.get('workEmail').hasError('maxword')">
                    {{FORMERROR.EMAIL_MAX}}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <label for="phone" class="control-label required-field col-sm-4 text-right">Phone No</label>
                <div class="col-sm-8">
                  <input maxlength="16" type="tel" id="phone" formControlName="phone" placeholder="Phone Number"
                    class="form-control input-sm" required>
                  <div *ngIf="contactUs.get('phone').hasError('required') && contactUs.get('phone').touched"
                    class="error-msg">
                    Phone number is required.
                  </div>
                  <div class="error-msg" *ngIf="contactUs.get('phone').hasError('maxword')">
                    {{FORMERROR.PHONE_MAX}}
                  </div>
                  <div class="error-msg"
                    *ngIf="contactUs.get('phone').hasError('minword') && !contactUs.get('phone').hasError('pattern')">
                    {{FORMERROR.PHONE_MIN}}
                  </div>
                  <div class="error-msg"
                    *ngIf="contactUs.get('phone').hasError('pattern') && !contactUs.get('phone').hasError('maxword')">
                    {{FORMERROR.NUMBER_PATTERN}}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <label for="companyName" class="control-label required-field col-sm-4 text-right">Company Name</label>
                <div class="col-sm-8">
                  <input type="text" id="companyName" formControlName="companyName" placeholder="Company Name"
                    class="form-control input-sm" required>
                  <div *ngIf="contactUs.get('companyName').hasError('required') && contactUs.get('companyName').touched"
                    class="error-msg">
                    Company Name is required.
                  </div>
                  <div
                    *ngIf="contactUs.get('companyName').hasError('minlength') && contactUs.get('companyName').touched"
                    class="error-msg">
                    Company Name must be at least 5 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <label for="companySize" class="control-label required-field col-sm-4 text-right">Company Size</label>
                <div class="col-sm-8">
                  <select id="companySize" formControlName="companySize" placeholder="Company Name"
                    class="form-control input-sm" required>
                    <option value="null" selected disabled>Select Company Size</option>
                    <option value="0-10">0-10</option>
                    <option value="11-50">11-50</option>
                    <option value="51-250">51-250</option>
                    <option value="251-500">251-500</option>
                    <option value="501-1000">501-1000</option>
                    <option value="1,001-5,000">1,001-5,000</option>
                    <option value="5,001-10,000">5,001-10,000</option>
                    <option value="10,001-25,000">10,001-25,000</option>
                    <option value="25,001-50,000">25,001-50,000</option>
                  </select>
                  <div *ngIf="contactUs.get('companySize').hasError('required') && contactUs.get('companySize').touched"
                    class="error-msg">
                    Please select a company size.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <label for="country" class="control-label required-field col-sm-4 text-right">Country</label>
                <div class="col-sm-8">
                  <select id="country" formControlName="country" class="form-control input-sm" required>
                    <option value="null" selected disabled>Select Country</option>
                    <option *ngFor="let country of countries" [value]="country.countryName">
                      {{country.countryName}}</option>
                  </select>
                  <div *ngIf="contactUs.get('country').hasError('required') && contactUs.get('country').touched"
                    class="error-msg">
                    Please select a country.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-panel-footer">
          <div class="panel-footer">
            <div class="footer-flex">
              <button type="button" class="btn btn-default" (click)="closeModel()"> Cancel </button>
              <button type="button" [disabled]="duplicatedata" class="btn btn-primary" (click)="onSubmit()"> Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>








